import { motion } from 'framer-motion';

// New EasyPassing brand logo (navy rounded-square icon: tree of life + family + caring hand + sunrise)
const ICON_SRC = '/logo-mark.png';

const SIZES = {
  sm: { icon: 'w-9 h-9', text: 'text-lg' },
  md: { icon: 'w-11 h-11', text: 'text-2xl' },
  lg: { icon: 'w-20 h-20', text: 'text-3xl' },
  xl: { icon: 'w-28 h-28', text: 'text-5xl' },
};

function Wordmark({ className = '' }) {
  return (
    <span className={`font-display font-bold tracking-tight ${className}`}>
      <span className="text-[#2B4C7E]">Easy</span>
      <span className="text-[#C8A97E]">Passing</span>
    </span>
  );
}

// Animated logo (subtle hover lift) — used on marketing/nav surfaces
export function AppLogo({ size = 'md', showText = true }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className="flex items-center gap-3">
      <motion.img
        src={ICON_SRC}
        alt="EasyPassing logo"
        className={`${s.icon} rounded-2xl object-cover shadow-md shadow-[#2B4C7E]/20`}
        whileHover={{ scale: 1.06, rotate: -2 }}
        transition={{ type: 'spring', stiffness: 300, damping: 18 }}
      />
      {showText && <Wordmark className={s.text} />}
    </div>
  );
}

// Static logo (no animation) — used inside dashboards/headers
export function AppLogoStatic({ size = 'md', showText = true }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className="flex items-center gap-3">
      <img
        src={ICON_SRC}
        alt="EasyPassing logo"
        className={`${s.icon} rounded-2xl object-cover shadow-sm shadow-[#2B4C7E]/20`}
      />
      {showText && <Wordmark className={s.text} />}
    </div>
  );
}

// Icon-only, animated — used by the Nova assistant bubble
export function AppIcon({ size = 48, className = '' }) {
  return (
    <motion.img
      src={ICON_SRC}
      alt="EasyPassing"
      width={size}
      height={size}
      className={`rounded-xl object-cover ${className}`}
      style={{ width: size, height: size }}
      whileHover={{ scale: 1.05 }}
      transition={{ type: 'spring', stiffness: 300, damping: 18 }}
    />
  );
}

export default AppLogo;
